
import ssoImg1 from "./../../../../assets/images/150.png"; 
import pdfIcon from "./../../../../assets/images/pdf.png"; 

import { FaFacebookF, FaLinkedinIn, FaTwitter, FaYoutube, FaUser, FaInstagram } from 'react-icons/fa';

function MoshOverviewTab() {  
 const documents = [
      {
        title: "National Fishing Forum",
        modified: "2019/08/05  10.35 AM",
        items: [
          "Notification_of_intention_to_build_0.",
        ],
      },
      // {
      //   title: "Casualty Report",
      //   modified: "2019/08/05  10.35 AM",
      //   items: [
      //     "INS-701-08-01 IMDG Explosive Area Inspection - Class 1",
      //     "INS-701-08-03 Container Inspection Form",
      //     "INS-701-09-01 Towage Inspection",
      //   ],
      // },
    ];
  return (
    <>
      <div className="service-title font-700 mb-3 text-uppercase">
        MOSR
        <span className="text-orange-ef3e33 font-400"> Overview </span>
      </div>

      <div className="row g-3 g-sm-4 g-md-5">
        <div className="col-lg">
          <p className="mb-3 text-primary-color">
            SAMSA is the custodian of the Maritime Occupational Safety Regulations, 1994 (MOSR) which are Regulations under the Merchant Shipping Act, 1951. The Regulations sets out safety standards for all work onboard vessels whether the vessels are in and out of the water. The Occupational Health and Safety Act which sets out safety standards in the workplace is not applicable onboard vessels that are subject to the Merchant Shipping Act, 1951. This area of work falls within the SAMSA’s objective of ensuring safety of life and property at sea.
            </p>
          <p className="mb-3 text-primary-color">
            The MOSR compliance regime covers wide ranging areas which includes work taking place whilst the vessel is in operation, work taking place whilst the vessel is involved in cargo operations (stevedoring), work involving ship repair and maintenance and incidental persons on board a vessel in the course and scope of their duty i.e. Port Agents, Authorities, ship visitors etc.
            </p>
          
        </div>
        {/* <div className="col-lg-5">
          <img src={ssoImg1} className="img-fluid rounded-1" alt="" />
        </div> */}
        <div className="col-12">
          <div className="accordion blackTab" id="blackTab">
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#blackTabOne"
                  aria-expanded="true"
                  aria-controls="blackTabOne"
                >SAMSA manages the compliance regime through the following:</button>
              </h2>
              <div
                id="blackTabOne"
                className="accordion-collapse collapse show"
                data-bs-parent="#blackTab"
              >
                <div className="accordion-body">
                  <ul className="strip-ul">
            {documents.map((doc, index) => (
              <li key={index}>
                <div className="row g-4">
                  {/* <div className="col-auto">
                    <img src={pdfIcon} alt="PDF icon" />
                  </div> */}
                  <div className="col">
                    <div className="row g-4">
                      <div className="col-md-auto">
                        <div className="font-18 font-600">
                            <ul class="green-star-ul">
                                      <li> Maritime Occupational Safety inspections
                                      </li>
                                      <li>Maritime Occupational Safety Audits 
                                        </li>
                                      <li>Maritime Occupational Safety awareness campaigns
                                        </li>
                                      <li>Stakeholder engagements
                                        </li>
                                      <li>Casualty investigations
                                        </li></ul>
                                        </div>
                       
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            ))}
          </ul>
                 </div>
              </div>
            </div>
        
           
          </div>
        </div>
      </div>
    </>
  );
}

export default MoshOverviewTab